import { Button, Grid, MenuItem, TextField, Typography } from '@mui/material';
import { FormikValues } from 'formik';
import { map } from 'lodash';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { APPLICATION_DECLINE_REASONS } from '../../../constants/options/application-decline-reasons';
import { BaseDialog } from '../../dialogs';
import { FIELD_EXPLANATION, FIELD_REASON } from './applications-decline-schema';
import { useApplicationsDecline } from './useApplicationsDecline';

interface ApplicationRejectDialogProps {
  title?: string;
  text?: string;
  previewLanguage?: string;
  popDialog?: any;
  onSubmit: (values: FormikValues) => void;
}

export const ApplicationsDeclineDialog: ComponentType<ApplicationRejectDialogProps> = ({
  title: dialogTitle,
  previewLanguage = 'oz',
  text,
  popDialog,
  onSubmit,
  ...props
}) => {
  const { t } = useTranslation();
  const { formik, handleFieldChange, hasError, getErrorMessage } = useApplicationsDecline({
    onSubmit,
  });

  const title = dialogTitle ? dialogTitle : t('application.decline.title', 'Отклонить заявку');
  const reasons = map(APPLICATION_DECLINE_REASONS, ({ label, value }, key) => (
    <MenuItem {...{ value, key }}>{t(label, value)}</MenuItem>
  ));

  return (
    <BaseDialog {...{ ...props, popDialog, title }}>
      {text && (
        <Typography variant="h5" component="p" mb={4}>
          {text}
        </Typography>
      )}
      <form onSubmit={formik.handleSubmit}>
        <Grid container mb={4} direction="column" spacing={1}>
          <Grid item>
            <TextField
              {...formik.getFieldProps(FIELD_REASON)}
              onChange={(e: any) => handleFieldChange(FIELD_REASON, e)}
              error={hasError(FIELD_REASON)}
              helperText={getErrorMessage(FIELD_REASON)}
              label={t('application.decline.reason.label', 'Причина')}
              placeholder={t('application.decline.reason.placeholder', 'Выберите причину')}
              fullWidth
              select
            >
              {reasons}
            </TextField>
          </Grid>
          <Grid item>
            <Typography variant="subtitle3" mb={2} display="block">
              {t(
                'application.decline.preferedLanguage',
                'На каком языке надо подавать ответ об отказе'
              )}
              : {t(`application.decline.preferedLanguageValue.${previewLanguage}`)}
            </Typography>
            <TextField
              {...formik.getFieldProps(FIELD_EXPLANATION)}
              onChange={(e: any) => handleFieldChange(FIELD_EXPLANATION, e)}
              error={hasError(FIELD_EXPLANATION)}
              helperText={getErrorMessage(FIELD_EXPLANATION)}
              label={t('application.decline.explanation.label', 'Пояснение')}
              placeholder={t('application.decline.explanation.placeholder', 'Введите пояснение...')}
              fullWidth
              multiline
              rows={4}
            />
          </Grid>
        </Grid>
        <Grid container columnSpacing={2} justifyContent="flex-end">
          <Grid item xs={6}>
            <Button
              onClick={popDialog}
              variant="outlined"
              size="large"
              fullWidth
              sx={{ minWidth: 0 }}
            >
              {t('cancel', 'Отмена')}
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              type="submit"
              variant="contained"
              color="error"
              size="large"
              fullWidth
              sx={{ minWidth: 0 }}
            >
              {t('action.decline', 'Отклонить')}
            </Button>
          </Grid>
        </Grid>
      </form>
    </BaseDialog>
  );
};
